(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-main-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
  const disclosure = event.target.closest('.rss-collapsible-mega .rss-mega-disclosure[open]');
  if (!disclosure) return;
  event.preventDefault();
  disclosure.open = false;
  disclosure.querySelector('summary').focus({ preventScroll: true });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rss-chat-welcome"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const bubble = document.getElementById('rss-chat-welcome');
    if (!bubble || bubble.dataset.ready) return;
    bubble.dataset.ready = 'true';
    const previewMode = bubble.dataset.preview === 'true';
    const key = 'rss-chat-welcome-shown-v3';
    try { if (!previewMode && sessionStorage.getItem(key)) return; } catch (_) {}
    let stopped = false;
    let shown = false;
    let timer;
    let poll;
    const remember = () => { if (previewMode) return; try { sessionStorage.setItem(key, '1'); } catch (_) {} };
    const dismiss = () => { stopped = true; clearTimeout(timer); clearInterval(poll); bubble.hidden = true; remember(); };
    const findButton = () => {
      const chat = document.querySelector('shopify-chat');
      if (!chat) return null;
      const roots = [chat];
      while (roots.length) {
        const root = roots.shift();
        const button = root.querySelector('button.activator, button[aria-label*="Open chat"]');
        if (button && button.getBoundingClientRect().width) return button;
        if (root.shadowRoot) roots.push(root.shadowRoot);
        root.querySelectorAll('*').forEach(el => { if (el.shadowRoot) roots.push(el.shadowRoot); });
      }
      return null;
    };
    const update = () => {
      if (stopped) return;
      const button = findButton();
      if (button && button.getAttribute('aria-expanded') === 'true') { dismiss(); return; }
      const rect = button && button.getBoundingClientRect();
      const usable = rect && rect.width && rect.height;
      const width = document.documentElement.clientWidth;
      bubble.style.left = Math.max(16, Math.min(usable ? rect.left : 20, width - Math.min(280, width - 32) - 16)) + 'px';
      bubble.style.bottom = usable ? Math.max(16, innerHeight - rect.top + 12) + 'px' : 'calc(180px + env(safe-area-inset-bottom, 0px))';
      bubble.querySelector('.rss-chat-welcome__cta').hidden = !button;
      if (shown) bubble.hidden = false;
    };
    bubble.querySelector('.rss-chat-welcome__close').addEventListener('click', dismiss);
    bubble.querySelector('.rss-chat-welcome__message').addEventListener('click', () => {
      const button = findButton();
      if (!button) return;
      dismiss();
      if (button.getAttribute('aria-expanded') !== 'true') setTimeout(() => button.click(), 0);
    });
    window.addEventListener('resize', update, {passive:true});
    if (window.visualViewport) window.visualViewport.addEventListener('resize', update, {passive:true});
    timer = setTimeout(() => {
      if (stopped) return;
      shown = true;
      update();
      if (!stopped) remember();
    }, 15000);
    poll = setInterval(update, 1000);
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
